import { useState } from 'react';
import { ClarityEvents } from '../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../lib/clarity/utils/captureEvent.utils';
import AnnouncementBar from './AnnouncementBar';
import AnnouncementModal from './AnnouncementModal';
import { useAnnouncementBar } from './hooks/useAnnouncementBar';

const AnnouncementBarContainer = () => {
  const { announcement, isVisible, dismiss } = useAnnouncementBar();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isVisible || !announcement) {
    return null;
  }

  const openModal = withEvent(
    `${ClarityEvents.ANNOUNCEMENT_BAR_CLICKED_LEARN_MORE_WITH_TITLE} ${announcement.content.title}`,
    () => setIsModalOpen(true),
  );

  return (
    <>
      <AnnouncementBar barText={announcement.barText} onLearnMore={openModal} onDismiss={dismiss} />

      <AnnouncementModal
        isOpen={isModalOpen}
        publishedAt={announcement.publishedAt}
        content={announcement.content}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default AnnouncementBarContainer;
